'use strict';

var buildDateUnitMethods = require('../internal/buildDateUnitMethods');

buildDateUnitMethods();


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/build/buildDateUnitMethodsCall.js
// module id = 5
// module chunks = 0